import SlideToggle from "./slide-toggle.js";

class SideNav {
  constructor(element) {
    // Check if already initialized
    if (element.dataset.sideNavInitialized === "true") {
      return;
    }

    this.element = element;
    this.wrapper = element.closest(".side-nav-wrapper");
    this.slideToggles = [];
    this.mobileToggle = null;
    this.init();

    // Mark as initialized
    element.dataset.sideNavInitialized = "true";
  }

  init() {
    // Initialize mobile toggle if exists
    if (this.wrapper) {
      const mobileToggleButton = this.wrapper.querySelector("[data-toggle-nav]");

      if (mobileToggleButton) {
        this.mobileToggle = new SlideToggle(mobileToggleButton, this.element, {
          duration: 300,
          easing: "ease-in-out",
          useHidden: false, // Use class instead of hidden attribute
          toggleClass: "is-open",
        });
      }
    }

    // Initialize all submenu toggle buttons
    const toggleButtons = this.element.querySelectorAll("[data-toggle-nav]");

    toggleButtons.forEach((button) => {
      const submenu = button.closest(".side-nav__item-wrapper").nextElementSibling;

      if (submenu && submenu.classList.contains("side-nav__list")) {
        const slideToggle = new SlideToggle(button, submenu, {
          duration: 300,
          easing: "ease-in-out",
        });

        this.slideToggles.push(slideToggle);
      }
    });

    // Open parent menus of active links on page load (without animation)
    this.expandActiveItems();
  }

  expandActiveItems() {
    const activeLinks = this.element.querySelectorAll(".side-nav__link--active");

    activeLinks.forEach((link) => {
      let parent = link.closest(".side-nav__item");

      // Walk up the tree and expand all parent menus
      while (parent) {
        const parentItem = parent.parentElement.closest(".side-nav__item");

        if (parentItem) {
          const toggleButton = parentItem.querySelector(
            ":scope > .side-nav__item-wrapper > [data-toggle-nav]"
          );

          if (toggleButton) {
            // Find the corresponding SlideToggle instance and expand without animation
            const slideToggle = this.slideToggles.find((st) => st.trigger === toggleButton);
            if (slideToggle) {
              slideToggle.expand();
            }
          }
        }

        parent = parentItem;
      }
    });
  }
}

// Initialize all side navs on the page
document.addEventListener("DOMContentLoaded", () => {
  const sideNavs = document.querySelectorAll(".side-nav");
  sideNavs.forEach((nav) => new SideNav(nav));
});

export default SideNav;
